﻿﻿export interface IContactPosition {
    contactPositionId: number;
    description: string;
}
